import { useEffect, useState } from "react";
import fetchData from "../../shared/fetchData";
import { updateObject, checkValidity } from "../../shared/utility";
import Input from "../../components/UI/Input/Input";
import DatePicker from "../../components/UI/DatePicker/DatePicker";
import TimePicker from "../../components/UI/TimePicker/TimePicker";
import Button from "../../components/UI/Button/Button";
import Search from "../../components/UI/Search/Search";
import ReactPaginate from 'react-paginate';
import CourierRequestLog from "../../components/CourierRequestLog/CourierRequestLog";
import * as FileSaver from "file-saver"
import * as XLSX from "xlsx"

const CourierRequestLogs = () => {
    const [offset, setOffset] = useState(1)
    const [perPage, setPerPage] = useState(5)
    const [pageCount, setPageCount] = useState(0)
    const [courierLogs, setCourierLogs] = useState([])
    const [logDate, setLogDate] = useState('')
    const [logTime, setLogTime] = useState('')
    const [loading, setLoading] = useState(false)
    const [rerener, setRerender] = useState(false)
    const [searchParams, setSearchParams] = useState({
        url: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'سرویس'
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        request: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'درخواست'
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        response: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'پاسخ'
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        exception: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'خطا'
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        user: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'کاربر'
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
    })

    useEffect(() => {
        getCourierRequestLogs({
            "pl": perPage,
            "pn": "1"
        });
    }, [])
    const logDateChange = (unix, formatted) => {
        setLogDate(formatted)
    }
    const changeLogTime = (value) => {
        setLogTime(value)
    }
    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(searchParams, {
            [controlName]: updateObject(searchParams[controlName], {
                value: event.target.value,
                valid: checkValidity(event.target.value, searchParams[controlName].validation)
            })
        });
        setSearchParams(updatedControls)
    }
    const exportToCSV = (event) => {

        var raw = JSON.stringify({
            "courierRequestLogDto": {
                "logDate": logDate,
                "logTime": logTime,
                "url": searchParams.url.value,
                "request": searchParams.request.value,
                "response": searchParams.response.value,
                "exception": searchParams.exception.value,
                "user": searchParams.user.value,
            },
            "pl": "1048576",
            "pn": "1",
            "version": "mtpx001"
        })
        var url = 'management/api/v1/courierRequestLogs/getCourierRequestLogs'
        fetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    let exportOrderReport = []
                    let count = 0
                    const orderReport = result.courierRequestLogDtos.map(o => {
                        count++
                        exportOrderReport.push({
                            'ردیف': count,
                            'تاریخ لاگ': o.logDate,
                            'ساعت لاگ': o.logTime,
                            "سرویس": o.url,
                            "خطا": o.exception,
                            "کاربر": o.user,
                            "درخواست": o.request,
                            "پاسخ": o.response,
                        })
                    })
                    const fileType =
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                    const fileExtension = ".xlsx";
                    const ws = XLSX.utils.json_to_sheet(exportOrderReport);
                    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                    const data = new Blob([excelBuffer], { type: fileType });
                    FileSaver.saveAs(data, 'logs' + fileExtension)
                }
            })
            .catch(error => setLoading(false))
        setLoading(true)
    }

    const getCourierRequestLogs = req => {
        console.log(req)
        var raw = JSON.stringify(req)
        var url = 'management/api/v1/courierRequestLogs/getCourierRequestLogs'
        fetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    setCourierLogs(result.courierRequestLogDtos);
                    setPageCount(result.count / parseInt(perPage))
                }
            })
            .catch(error => setLoading(false))
    }
    const search = () => {
        var raw = {
            "courierRequestLogDto": {
                "logDate": logDate,
                "logTime": logTime,
                "url": searchParams.url.value,
                "request": searchParams.request.value,
                "response": searchParams.response.value,
                "exception": searchParams.exception.value,
                "user": searchParams.user.value,
            },
            "pl": perPage,
            "pn": "1",
            "version": "mtpx001"
        }
        getCourierRequestLogs(raw);
    }
    const handlePageClick = (e) => {
        setOffset(e.selected + 1)
        var raw = {
            "courierRequestLogDto": {
                "logDate": logDate,
                "logTime": logTime,
                "url": searchParams.url.value,
                "request": searchParams.request.value,
                "response": searchParams.response.value,
                "exception": searchParams.exception.value,
                "user": searchParams.user.value,
            },
            "pl": perPage,
            "pn": e.selected + 1,
            "version": "mtpx001"
        }
        getCourierRequestLogs(raw);
    }
    const refresh = () => {
        const srch = searchParams
        for (let key in srch) {
            srch[key].value = ''
        }
        var raw = {
            "courierRequestLogDto": {
            },
            "pl": perPage,
            "pn": "1",
            "version": "mtpx001"
        }
        getCourierRequestLogs(raw);
        setSearchParams(srch);
        setLogDate('');
        setLogTime('');
        setRerender(!rerener);
    }
    const formElementsArray = [];
    for (let key in searchParams) {
        formElementsArray.push({
            id: key,
            config: searchParams[key]
        });
    }
    let form = formElementsArray.map(formElement => {
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                col="3"
                changed={(event) => inputChangedHandler(event, formElement.id)} />
        );
    });

    form = <div>
        <div className="row pl-4" dir="ltr">
        </div>
        <div className="row pl-4" dir="ltr">
            <Button btnType="Refresh" clicked={refresh}></Button>
        </div>
        <div className="row mt-4">
            <div className="col-3 small-date-col">
                <DatePicker change={logDateChange} value={logDate} placeHolder="تاریخ لاگ" />
            </div>
            <TimePicker
                onChange={changeLogTime}
                value={logTime}
                placeHolder="ساعت لاگ"
                className="report-time"
                col="3"
            />
            {form}
        </div>
        <div className="row text-left" dir="ltr">

            <div className='col-2 mt-4'>
                <Button btnType="Success" clicked={search} >جستجو</Button>
            </div>
            <div className="col-2 mt-4 text-left ord-small-btns">
                <Button btnType="Search" clicked={exportToCSV}>
                    <span className="tab-color">
                        گزارشگیری
                    </span>
                </Button>
            </div>
        </div>
    </div>

    let logs = []
    if (courierLogs !== null) {
        logs = courierLogs?.map(l => <CourierRequestLog log={l} />)
    }
    return (
        <div>
            <Search class="orders-search" form={form} />
            <div className="row justify-content-center mt-1">
                {logs}
            </div>
            {courierLogs != null && courierLogs.length != 0 ?
                <div className="row justify-content-center">
                    <ReactPaginate
                        previousLabel={"→قبلی"}
                        nextLabel={"بعدی←"}
                        forcePage={offset >= 0 ? offset - 1 : offset}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName="pagination"
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"} />
                </div>
                : ''}
        </div>
    )
}

export default CourierRequestLogs;